import { action } from 'typesafe-actions';

import { IErknmAnalyticsIndex } from 'APIPackage/ErknmAnalyticsModule/interfaces/IErknmAnalyticsIndex';
import { ExportFormatsEnum } from 'APIPackage/ImportExportModule/enums/ExportFormatsEnum';
import { IKnmRaw } from 'KnmListPackage/MainModule/interfaces/IKnmRaw';

import { ErknmAnalyticsActionsEnum } from '../enums/ErknmAnalyticsActionsEnum';
import { IErknmAnalyticsFilter } from '../interfaces/IErknmAnalyticsFilter';
import { IErknmAnalyticsTableColumn } from '../interfaces/IErknmAnalyticsTableColumn';

export const erknmAnalyticsInitPage = () => action(ErknmAnalyticsActionsEnum.ERKNM_ANALYTICS_INIT_PAGE);
export const erknmAnalyticsGetData = () => action(ErknmAnalyticsActionsEnum.ERKNM_ANALYTICS_GET_DATA);
export const erknmAnalyticsGetDataNext = () => action(ErknmAnalyticsActionsEnum.ERKNM_ANALYTICS_GET_DATA_NEXT);
export const erknmAnalyticsSetData = (
  data: IErknmAnalyticsIndex[],
  page: number,
  hasMoreData: boolean,
  localDateTime: string,
) => action(ErknmAnalyticsActionsEnum.ERKNM_ANALYTICS_SET_DATA, { data, page, hasMoreData, localDateTime });
export const erknmAnalyticsSetFilter = (filter: IErknmAnalyticsFilter) =>
  action(ErknmAnalyticsActionsEnum.ERKNM_ANALYTICS_SET_FILTER, { filter });
export const erknmAnalyticsSetTableColumns = (columns: IErknmAnalyticsTableColumn[]) =>
  action(ErknmAnalyticsActionsEnum.ERKNM_ANALYTICS_SET_TABLE_COLUMNS, { columns });
export const erknmAnalyticsGetAdditionalColumns = (columnId: IErknmAnalyticsTableColumn['id']) =>
  action(ErknmAnalyticsActionsEnum.ERKNM_ANALYTICS_GET_ADDITIONAL_COLUMNS, { columnId });
export const erknmAnalyticsExport = (format: ExportFormatsEnum) =>
  action(ErknmAnalyticsActionsEnum.ERKNM_ANALYTICS_EXPORT, { format });
export const erknmAnalyticsExportKnmList = (
  r: string,
  c: string,
  f: string | null,
  filter: IErknmAnalyticsFilter,
  format: ExportFormatsEnum,
) => action(ErknmAnalyticsActionsEnum.ERKNM_ANALYTICS_EXPORT_KNM_LIST, { r, c, f, filter, format });
export const erknmAnalyticsGetKnmList = (r: string, c: string, f: string | null, filter: IErknmAnalyticsFilter) =>
  action(ErknmAnalyticsActionsEnum.ERKNM_ANALYTICS_GET_KNM_LIST, {
    r,
    c,
    f,
    filter,
  });
export const erknmAnalyticsGetKnmListNextPage = (
  r: string,
  c: string,
  f: string | null,
  filter: IErknmAnalyticsFilter,
) =>
  action(ErknmAnalyticsActionsEnum.ERKNM_ANALYTICS_GET_KNM_LIST_NEXT_PAGE, {
    r,
    c,
    f,
    filter,
  });
export const erknmAnalyticsSetKnmList = (data: IKnmRaw[], page: number, pageCount: number, totalCount: number) =>
  action(ErknmAnalyticsActionsEnum.ERKNM_ANALYTICS_SET_KNM_LIST, {
    data,
    page,
    pageCount,
    totalCount,
  });
export const erknmAnalyticsSetOrder = (order: string | null) =>
  action(ErknmAnalyticsActionsEnum.ERKNM_ANALYTICS_SET_ORDER, {
    order,
  });
